import { render, staticRenderFns } from "./CustomerFilter.vue?vue&type=template&id=33677ca0"
import script from "./CustomerFilter.vue?vue&type=script&lang=js"
export * from "./CustomerFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports